import { MaskedLines, Reveal } from "@/components/Motion";
import { SectionLabel } from "@/components/SectionLabel";

export const PageIntro = ({ label, lines, text, children, testid }) => (
  <section className="relative pb-16 pt-16 sm:pb-24 sm:pt-24" data-testid={testid}>
    <div className="shell">
      <SectionLabel>{label}</SectionLabel>
      <MaskedLines
        as="h1"
        onMount
        className="mt-8 max-w-6xl font-display text-[2.6rem] font-extrabold leading-[1.02] tracking-[-0.045em] text-navy sm:text-6xl lg:text-7xl xl:text-[5.5rem]"
        lines={lines}
      />
      {text && (
        <Reveal delay={0.45} className="mt-10 max-w-2xl text-base leading-relaxed text-slatey sm:text-lg">
          <p>{text}</p>
        </Reveal>
      )}
      {children}
    </div>
  </section>
);
